import { motion } from "framer-motion";
import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function Newsletter() {
  const { lang } = useLang();
  const en = lang === "en";
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, first_name: firstName });
      toast.success(data.message || "Abonnement confirmé");
      setEmail(""); setFirstName("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12 bg-fg text-bg overflow-hidden" data-testid="newsletter">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="md:col-span-7"
        >
          <div className="meta-label text-cinabre">§ Newsletter · {en ? "The Thread" : "Le Fil"}</div>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
            {en ? <>Stay in <em className="italic">the thread</em>.</> : <>Rester dans <em className="italic">le fil</em>.</>}
          </h2>
          <p className="mt-6 text-bg/75 max-w-xl leading-relaxed text-lg">
            {en
              ? "Openings, stops, calls for artists — receive the key dates of the world's largest open-air art trail."
              : "Vernissages, escales, appels à artistes — recevez les rendez-vous du plus grand parcours artistique à ciel ouvert du monde."}
          </p>
        </motion.div>

        <form onSubmit={onSubmit} className="md:col-span-5 self-end w-full" data-testid="newsletter-form">
          <div className="mb-4">
            <label className="meta-label text-bg/60 block mb-2">{en ? "First name (optional)" : "Prénom (optionnel)"}</label>
            <input
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full bg-transparent border-b border-bg/40 focus:border-cinabre outline-none py-3 font-serif text-2xl"
              data-testid="newsletter-firstname"
            />
          </div>
          <div className="mb-6">
            <label className="meta-label text-bg/60 block mb-2">Email *</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-bg/40 focus:border-cinabre outline-none py-3 font-serif text-2xl"
              data-testid="newsletter-email"
              placeholder="vous@exemple.fr"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-editorial bg-bg text-fg border-bg hover:bg-cinabre hover:text-bg hover:border-cinabre disabled:opacity-50"
            data-testid="newsletter-submit"
          >
            {loading ? (en ? "Sending..." : "Envoi...") : (en ? "Subscribe" : "S'inscrire")} <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </section>
  );
}
